import router from "../../router";

import blocksService from "@/services/blocksService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await blocksService.create(formData);
      dispatch(
        "common/showSuccess",
        `Seite #${res.data.id} wurde erfolgreich angelegt.`,
        { root: true }
      );
      router.push({ name: "CMSPromotionEdit", params: { id: res.data.id } });
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Seite konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await blocksService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Seiten konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await blocksService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve({...res.data});
    } catch (error) {
      dispatch(
        "common/showError",
        "Seite konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await blocksService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Seite konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await blocksService.update(formData);
      // dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Seite wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Seite konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateActive({ dispatch }, formData) {
    try {
      const res = await blocksService.updateActive(formData);
      // dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Seiten-Status wurde aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Seiten-Status konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async clone({ dispatch }, formData) {
    try {
      const res = await blocksService.clone(formData);
      // dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Seite wurde erfolgreich geklont.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Seite wurde erfolgreich geklont.",
        { root: true }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
